/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectBudgetResourceAmounts } from './';
import {
    ProjectBudgetResourceAmountsFromJSON,
    ProjectBudgetResourceAmountsFromJSONTyped,
    ProjectBudgetResourceAmountsToJSON,
} from './';
import type { ProjectBudgetResourceWork } from './';
import {
    ProjectBudgetResourceWorkFromJSON,
    ProjectBudgetResourceWorkFromJSONTyped,
    ProjectBudgetResourceWorkToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectBudgetResource
 */
export interface ProjectBudgetResource {
    /**
     * 
     * @type {ProjectBudgetResourceAmounts}
     * @memberof ProjectBudgetResource
     */
    amounts: ProjectBudgetResourceAmounts;
    /**
     * 
     * @type {ProjectBudgetResourceWork}
     * @memberof ProjectBudgetResource
     */
    work?: ProjectBudgetResourceWork;
}

/**
 * Check if a given object implements the ProjectBudgetResource interface.
 */
export function instanceOfProjectBudgetResource(value: object): value is ProjectBudgetResource {
    if (!('amounts' in value) || value['amounts'] === undefined) return false;
    return true;
}

export function ProjectBudgetResourceFromJSON(json: any): ProjectBudgetResource {
    return ProjectBudgetResourceFromJSONTyped(json, false);
}

export function ProjectBudgetResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectBudgetResource {
    if (json == null) {
        return json;
    }
    return {
        
        'amounts': ProjectBudgetResourceAmountsFromJSON(json['amounts']),
        'work': json['work'] == null ? undefined : ProjectBudgetResourceWorkFromJSON(json['work']),
    };
}

export function ProjectBudgetResourceToJSON(value?: ProjectBudgetResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amounts': ProjectBudgetResourceAmountsToJSON(value['amounts']),
        'work': ProjectBudgetResourceWorkToJSON(value['work']),
    };
}

